import { render } from "./CookiesSlider.vue?vue&type=template&id=93cd80c8&scoped=true&ts=true"
import script from "./CookiesSlider.vue?vue&type=script&lang=ts"
export * from "./CookiesSlider.vue?vue&type=script&lang=ts"

import "./CookiesSlider.vue?vue&type=style&index=0&id=93cd80c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93cd80c8"]])

export default __exports__